import {
    EduTradingFetchCryptoCalendarEvents,
    EduTradingFetchEconomicCalendarEvents,
    EduTradingSetCryptoCalendarDateFilter,
    EduTradingSetCryptoCalendarFilters,
    EduTradingSetEconomicCalendarDateFilter,
    EduTradingSetEconomicCalendarFilters,
} from "core/redux/eduTrading/EduTradingReduxActions";
import {EduFilterDate, EduFilterValue} from "core/redux/eduTrading/EduTradingReduxState";
import {RouteType} from "core/router/Routes";
import {EduCalendarFilterType} from "enum/EduCalendarFilterType";
import {EduTradingTradeContentTab} from "enum/EduTradingTradeContentTab";
import {EnvType} from "platform/enum/EnvType";
import Platform from "platform/Platform";
import {StrengthsItem} from "protocol/edutrading/EduTradingCurrencyStrengthMeterResponse";
import {EduTradingCurrencyStrengthType} from "protocol/edutrading/EduTradingCurrencyStrengthType";
import {TrendItem} from "protocol/edutrading/EduTradingTrendAnalysisResponse";
import {TSMap} from "typescript-map";

export class EduTableFilterUtil {

    private constructor() {
    }

    public static hasTableFilterType = (routeType: RouteType, filterType: EduCalendarFilterType) => {
        switch (filterType) {
            case EduCalendarFilterType.Currency:
                return routeType === RouteType.EconomicCalendar || routeType === RouteType.TradingSignals;
            case EduCalendarFilterType.Impact:
                return routeType === RouteType.CryptocurrencyCalendar || routeType === RouteType.TradingSignals || routeType === RouteType.EconomicCalendar;
            default:
                return false;
        }
    }

    public static setTableFilters = (tableType: RouteType, Filters: TSMap<EduCalendarFilterType, EduFilterValue[]>) => {
        switch (tableType) {
            case RouteType.EconomicCalendar:
                return EduTradingSetEconomicCalendarFilters({filters: Filters});
            case RouteType.CryptocurrencyCalendar:
                return EduTradingSetCryptoCalendarFilters({filters: Filters});
            default:
                return null;
        }
    }

    public static getTableFilters = (tableType: RouteType, economicCalendarFilters: TSMap<string, EduFilterValue[]>, cryptoCalendarFilters: TSMap<string, EduFilterValue[]>): TSMap<string, EduFilterValue[]> => {
        switch (tableType) {
            case RouteType.EconomicCalendar:
                return economicCalendarFilters;
            case RouteType.CryptocurrencyCalendar:
                return cryptoCalendarFilters;
            default:
                return null;
        }
    }

    public static getDateFilters = (tableType: RouteType, economicCalendarDateFilter: EduFilterDate, cryptoCalendarDateFilter: EduFilterDate): EduFilterDate => {
        switch (tableType) {
            case RouteType.EconomicCalendar:
                return economicCalendarDateFilter;
            case RouteType.CryptocurrencyCalendar:
                return cryptoCalendarDateFilter;
            default:
                return null;
        }
    }

    public static setDateFilters = (tableType: RouteType, date: EduFilterDate): void => {
        switch (tableType) {
            case RouteType.EconomicCalendar:
                Platform.dispatch(EduTradingSetEconomicCalendarDateFilter({dateFilter: date}));
                Platform.dispatch(EduTradingFetchEconomicCalendarEvents({dateFilter: date}));
                break;
            case RouteType.CryptocurrencyCalendar:
                Platform.dispatch(EduTradingSetCryptoCalendarDateFilter({dateFilter: date}));
                Platform.dispatch(EduTradingFetchCryptoCalendarEvents({dateFilter: date}));
                break;
            default:
                return null;
        }
    }

    public static getCurrentStrength = (strengthType: EduTradingCurrencyStrengthType, strengths: StrengthsItem[]): StrengthsItem => {
        return strengths?.find(strength => strength?.timeframe === strengthType);
    }

    public static getCurrentTrend = (strengthType: EduTradingCurrencyStrengthType, trends: TrendItem[]): TrendItem => {
        return trends?.find(trend => trend?.timeframe === strengthType);
    }

    public static showTableFilter = (route: RouteType): boolean => {
        switch (route) {
            case RouteType.EconomicCalendar:
            case RouteType.CryptocurrencyCalendar:
                return true;
            default:
                return false;
        }
    }

    public static showDateTableFilter = (route: RouteType): boolean => {
        switch (route) {
            case RouteType.EconomicCalendar:
            case RouteType.CryptocurrencyCalendar:
                return true;
            default:
                return false;
        }
    }

    public static showSearch = (route: RouteType, ActiveTab?: EduTradingTradeContentTab): boolean => {
        switch (route) {
            case RouteType.News:
            case RouteType.TechnicalAnalysisArticles:
            case RouteType.MarketHighlightsTV:
            case RouteType.MarketResearchVideos:
            case RouteType.TradingSignals:
                return true;
            case RouteType.Trade:
                return ActiveTab === EduTradingTradeContentTab.Trade;
            default:
                return false;
        }
    }

    public static compareFilters = (currentFilters: EduFilterValue[], newFilters: EduFilterValue[]): EduFilterValue[] => {
        const missingFilters: EduFilterValue[] = [];
        if (currentFilters.length > newFilters.length) {
            currentFilters.forEach((item) => {
                const filter = newFilters.find(filter => filter.name === item.name);
                if (!filter) {
                    missingFilters.push(item)
                }
            });
           return newFilters.concat(missingFilters);
        } else {
            return newFilters;
        }
    }

    public static isDefaultFilters = (routeType: RouteType, tableFilters: TSMap<string, EduFilterValue[]>): boolean => {
        const filters: TSMap<string, EduFilterValue[]> = tableFilters?.clone() || new TSMap();
        const currencyFilters: EduFilterValue[] = [];
        const impactFilters: EduFilterValue[] = [];
        EduTableFilterUtil.hasTableFilterType(routeType, EduCalendarFilterType.Currency) && currencyFilters.push(...filters.get(EduCalendarFilterType.Currency));
        EduTableFilterUtil.hasTableFilterType(routeType, EduCalendarFilterType.Impact) && impactFilters.push(...filters.get(EduCalendarFilterType.Impact));
        return !currencyFilters?.some((i) => !i.value) && !impactFilters?.some((i) => !i.value)
    }
}
